export default "/fonts/vendor/katex/dist/KaTeX_Fraktur-Bold.woff2?931d67ea207ab37ee693ff155ff4d7a6";